module.exports = __webpack_public_path__ + "static/media/12_l_korobka_18.85_81.67.e20c2b9d.png";